// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","742":"combined"}[chunkId] + "." + {"594":"3f3db872","742":"ee3bed29"}[chunkId] + ".css";
};